module.exports = __webpack_public_path__ + "img/h5_01.284f611c.jpg";